import { axiosWithAuth } from "helpers";
import { PaymentTypesType } from "types/enums/paymentTypes";

export const paymentMethodsService = {
	checkIfUsedPaymentMethod,
	getPaymentMethod,
	getPaymentMethodsList,
};

const API_URL = process.env.REACT_APP_API_URL;

function getPaymentMethodsList({
	page,
	applicationId,
	agentId,
	merchantId,
	isActive = true,
	paymentType,
	pageSize = 5,
	paymentMethodChosenId,
}: {
	page: number;
	applicationId?: string;
	agentId?: number | string;
	merchantId?: number | string;
	isActive?: boolean;
	paymentType?: PaymentTypesType;
	pageSize?: number;
	paymentMethodChosenId?: string;
}) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: pageSize,
			payment_type: paymentType,
			agent_id: agentId,
			merchant_id: merchantId,
			application_id: applicationId,
			chosen_payment_method_id: paymentMethodChosenId,
			is_active: isActive,
		},
		url: `${API_URL}/api/payment_methods`,
	};

	return axiosWithAuth(options);
}

function getPaymentMethod({
	paymentMethodId,
}: {
	paymentMethodId: number | string;
}) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/payment_methods/${paymentMethodId}`,
	};

	return axiosWithAuth(options);
}

function checkIfUsedPaymentMethod(paymentMethodId) {
	return axiosWithAuth({
		method: "GET",
		url: `${API_URL}/api/payment_methods/${paymentMethodId}/check_if_in_use`,
	});
}
